<template>
  <div>
    <Header />
    <div class="content-web container mt-5">
      <!-- Filter -->
      <!-- <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">Bộ lọc:</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <input
              v-model="searchForm.title"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Tiêu đề"
              v-on:keyup.enter="searchSubmission(true)"
            />
            <v-select
              style="width: 200px;"
              class="mr-2"
              placeholder="Tháng"
              :options="listPeriod"
              :reduce="obj => obj.code"
              label="name"
              v-model="searchForm.period"
            ></v-select>
            <v-select
              style="width: 250px;"
              class="mr-2"
              placeholder="Thao tác chấm"
              :options="[
                { code: 'scored', name: 'Đã thao tác chấm' },
                { code: 'notScored', name: 'Chưa thao tác chấm' }
              ]"
              :reduce="obj => obj.code"
              label="name"
              v-model="searchForm.userScored"
            ></v-select>
            <div>
              <button
                class="btn btn_control mr-1 mb-2"
                v-on:click="searchSubmission(true)"
              >
                Tìm kiếm
              </button>
              <button
                type="submit"
                class="btn btn_control mr-1 mb-2"
                v-on:click="clearSearch()"
              >
                Xóa
              </button>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Loading -->
      <div class="table-box list-grid mb-5" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div v-else class="table-box list-grid mb-5">
        <div class="title">
          <h6>DANH SÁCH CHẤM ĐIỂM</h6>
        </div>
        <div class="content-table">
          <table
            class="table table-hover table-md"
            style="overflow: inherit; table-layout: fixed;"
          >
            <thead>
              <tr style=" text-align:top;">
                <th style="width: 40px;"></th>
                <th style="width: 80px;">BẢNG</th>
                <th style="width: 60px;">ID</th>
                <th style="width: 200px;">TIÊU ĐỀ</th>
                <th style="width: 80px;">Tháng</th>
                <th style="width: 160px;">Kết quả</th>
                <th style="width: 110px;">CTTV</th>
                <th style="width: 150px;">Tác giả</th>
                <th style="width: 130px;">Loại hiệu quả</th>
                <th style="width: 130px;">Ước tính hiệu quả</th>
                <th style="width: 130px;">Thưởng sáng kiến</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="cell"
                v-for="(item, index) in submission"
                v-bind:key="item.id"
              >
                <td>
                  <b-icon
                    v-if="item.userScoredMedal"
                    icon="check-circle-fill"
                    font-scale="1.5"
                    variant="success"
                  ></b-icon>
                  <!-- <b-icon
                    v-else
                    icon="exclamation-circle-fill"
                    font-scale="1.5"
                    variant="warning"
                  ></b-icon> -->
                </td>
                <td>{{ item.periodTable }}</td>
                <td>{{ item.ideaId }}</td>
                <td style="word-break: break-word;">
                  <a v-bind:href="`${ipDetailUrl}/${item.ideaId}`">{{
                    item.ideaTitle
                  }}</a>
                </td>
                <td>{{ item.periodName }}</td>
                <!-- <td>{{getMedalName(item.userScoredMedal)}}</td> -->
                <td>
                  <v-select
                    :options="listMedal.filter(m => m.code !== 'noMedal')"
                    :reduce="obj => obj.code"
                    label="name"
                    v-model="
                      scoringUpdates[
                        `score_${
                          item.userScoredMedal
                            ? item.userScoredMedal
                            : 'noMedal'
                        }`
                      ].medal
                    "
                    @input="
                      changeMedal(
                        `score_${
                          item.userScoredMedal
                            ? item.userScoredMedal
                            : 'noMedal'
                        }`,
                        $event,
                        item.ideaId
                      )
                    "
                    :clearable="false"
                    placeholder="Chấm điểm"
                  ></v-select>
                  <!-- <div
                    v-for="(ideaActions, index) in ideaActionsList"
                    v-bind:key="index"
                  >
                    <div v-if="ideaActions.ideaId === item.ideaId">
                      <div
                        v-for="(action, index) in ideaActions.ideaActions"
                        v-bind:key="index"
                      >
                        <button
                          class="btn btn-info mb-1"
                          v-if="action.action === 'score'"
                          @click="
                            processIdea(ideaActions.ideaId, action.action)
                          "
                          :ref="action.action"
                          :id="'idea_action_' + action.action"
                        >
                          {{ action.actionName }}
                        </button>
                      </div>
                    </div>
                  </div> -->
                </td>
                <td>{{ item.companyName }}</td>
                <td style="word-break: break-word;">{{ item.author }}</td>
                <td>{{ item.effectiveType }}</td>
                <td>{{ item.effectiveEstimate | moneyFormat }}</td>
                <td>
                  <p>Công ty : {{ item.bonusMoney | moneyFormat }}</p>
                  <p>Tập đoàn: {{ item.groupBonusMoney | moneyFormat }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <b-modal ref="scoreIdea" hide-footer title="Chấm điểm sáng kiến">
          <div class="d-block">
            <validation-observer ref="formScoreIdea">
              <form>
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <div class="form-group">
                    <div v-for="list in lists" :key="list.id">
                      {{ list }}
                    </div>
                    <label class="required">Danh hiệu</label><br />
                    <b-form-select
                      v-model="ideaScoringForm.medal"
                      :options="listMedal"
                      value-field="code"
                      text-field="name"
                      :state="getValidationState(validationContext)"
                    ></b-form-select>
                    <b-form-invalid-feedback id="input-companyCode">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </div>
                </validation-provider>

                <!--<validation-provider :rules="{ required: true}" v-slot="validationContext">
                <div class="form-group">
                  <label class="required">Nhận xét</label>
                  <b-form-textarea
                    class="form-control"
                    v-model="ideaScoringForm.comment"
                    :state="getValidationState(validationContext)"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="input-required">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </div>
              </validation-provider>-->
              </form>
            </validation-observer>
          </div>
          <div style="float: right;">
            <button
              class="btn btn-info mr-2"
              @click="processIdea(null, 'score', 'submit')"
            >
              Gửi
            </button>
            <button
              class="btn btn-secondary"
              @click="processIdea(null, 'score', 'close')"
            >
              Đóng
            </button>
          </div>
        </b-modal>

        <div class="row mt-4 pagination">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
            <span v-if="pageSize * pageIndex > total && total != 0"
              >{{ pageSize * (pageIndex - 1) + 1 }}-{{ total }} của
              {{ total }}</span
            >
            <span v-if="pageSize * pageIndex <= total && total != 0"
              >{{ pageSize * (pageIndex - 1) + 1 }}-{{
                pageSize * pageIndex
              }}
              của {{ total }}</span
            >
            <span v-if="total == 0">0-0 của 0</span>
          </div>
          <div
            class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
          >
            <b-pagination
              v-if="total > pageSize"
              v-model="pageIndex"
              pills
              :total-rows="total"
              :per-page="pageSize"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios';
import * as CONFIG from '../../config/index';
import moment from 'moment';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { BPagination } from 'bootstrap-vue';

import MasterDataCommon from '../../common/masterData';
import ideaCommon from '../../common/idea';
import CompanyCommon from '../../common/company';
import ideaPeriodCommon from '../../common/ideaPeriod';
import periodCommon from '../../common/period';
import ideaWorkflowCommon from '../../common/ideaWorkflow';
import ideaScoringCommon from '../../common/ideaScoring';
import scoringResultCommon from '../../common/scoringResult';
import helper from '../../common/helper';

const date = new Date();
let currentMonth = date.getMonth() + 1;
const currentYear = date.getFullYear().toString();

if (currentMonth < 10) {
  currentMonth = '0' + currentMonth;
}

const defaultSearchForm = {
  title: '',
  period: currentYear + currentMonth,
  userScored: ''
};
export default {
  name: 'IdeasContest',
  components: {
    Header,
    Footer,
    'b-pagination': BPagination,
    DatePicker
  },
  data() {
    return {
      ipDetailUrl: `${CONFIG.CLIENT_URL}/#/admin/ip-view`,
      loading: false,
      searchForm: { ...defaultSearchForm },
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      listStatus: [],
      listType: [],
      submission: [],
      companys: [],
      listPeriod: [],
      ideaActionsList: [],
      ideaScoringForm: {
        medal: null
      },
      listMedal: [],
      idea: null,
      ideaId: null,
      scoringUpdates: {},
      colorScoring: {},
      listIdea: []
    };
  },
  filters: {
    date: function(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    moneyFormat(value) {
      if (value === 0) {
        return '0';
      }
      if (!value) {
        return '';
      }
      return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    }
  },
  methods: {
    async fetchData() {
      Promise.all([
        MasterDataCommon.sync.getByType('idea_status'),
        MasterDataCommon.sync.getByType('idea_type'),
        CompanyCommon.getAll()
      ]).then(res => {
        this.listStatus = res[0];
        this.listType = res[1];
        this.companys = res[2];
      });
    },
    refreshPage() {
      window.location.reload();
    },
    clearSearch() {
      this.clearFilterSearch();
      this.searchSubmission(true);
    },
    clearFilterSearch() {
      this.searchForm = { ...defaultSearchForm };
    },
    async searchSubmission(isFirstPage) {
      this.loading = true;
      if (isFirstPage) {
        this.pageIndex = 1;
      }
      const res = await ideaPeriodCommon.search(
        this.searchForm.title,
        this.searchForm.period,
        this.searchForm.userScored,
        'idea_contest',
        this.pageIndex,
        this.pageSize
      );
      this.submission = res.items;
      this.total = res.totals;
      this.loading = false;
    },
    getTypeName(code) {
      if (!code) {
        return '';
      }
      const typeData = this.listType.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return '';
    },
    getMedalName(medal) {
      return helper.getMedalName(medal);
    },
    async getIdeaActionsList(submission) {
      // console.log(`submission::`, submission);
      return Promise.all(
        submission &&
          submission.map(async function(sub) {
            const idea = await ideaCommon.getIdea(sub.ideaId);
            const ideaActions = await ideaWorkflowCommon.getAction(idea.status);
            // console.log({ idea, ideaActions });
            return { ideaId: sub.ideaId, ideaActions };
          })
      );
    },
    async getIdeaList(submission) {
      // console.log(`submission::`, submission);
      return Promise.all(
        submission &&
          submission.map(async function(sub) {
            const idea = await ideaCommon.getIdea(sub.ideaId);
            return idea;
          })
      );
    },
    getValidationState({ dirty, validated, valid = null }) {
      // console.log("getValidationState: dirty = " + dirty + ",validated =  " + validated + ", valid = " + valid)
      // console.log("dirty || validated ? valid " + dirty || validated ? valid : null)
      return dirty || validated ? valid : null;
    },
    async processIdea(ideaId, action, subAction) {
      let submit = false;
      if (!subAction) this.ideaId = ideaId;
      const form = {
        ideaId: this.ideaId,
        action: action,
        data: {}
      };
      let mesage = '';
      if ('score' === action) {
        if (!subAction) {
          this.$refs.scoreIdea.show();
        } else {
          if (subAction === 'submit') {
            const validate = await this.$refs.formScoreIdea.validate();
            if (validate) {
              this.ideaScoringForm.ideaId = this.ideaId;
              form.data = this.ideaScoringForm;
              submit = true;
              mesage = 'Đã chấm điểm thành công';
            } else {
              return;
            }
          } else {
            this.ideaScoringForm = {
              medal: null
            };
            this.$refs.scoreIdea.hide();
          }
        }
        this.$refs.scoreIdea.hide();
      }
      if (submit) {
        // console.log(`form::`, form);
        await ideaCommon.processIdea(form);
        this.idea = await ideaCommon.getIdea(this.ideaId);
        this.scoreExist = await ideaScoringCommon.checkExist(this.ideaId);
        if (this.scoreExist) {
          //this.$refs.score.setAttribute('disabled', 'true');
          if (document.getElementById('idea_action_score')) {
            document.getElementById('idea_action_score').disabled = true;
          }
        }
        if (this.idea) {
          helper.successMsg(mesage);
        }
        this.ideaActions = await ideaWorkflowCommon.getAction(this.idea.status);
      }
    },
    async changeMedal(key, medal, ideaId) {
      this.ideaId = ideaId;
      // console.log(medal);
      this.scoringUpdates[key].medal = medal;
      const form = {
        ideaId: this.ideaId,
        action: 'score',
        data: {}
      };
      let mesage = '';
      this.ideaScoringForm.ideaId = this.ideaId;
      this.ideaScoringForm.medal = medal;
      form.data = this.ideaScoringForm;
      await ideaCommon.processIdea(form);
      this.idea = await ideaCommon.getIdea(this.ideaId);
      // this.scoreExist = await ideaScoringCommon.checkExist(this.ideaId);
      // const ideaScoring = await ideaScoringCommon.getByIdeaId(this.ideaId);
      if (this.idea) {
        // this.colorScoring[ideaScoring[0].medal] = this.colorMedals[
        //   ideaScoring[0].medal
        // ];
        mesage = 'Đã chấm điểm thành công';
        helper.successMsg(mesage);
      }
      this.ideaActions = await ideaWorkflowCommon.getAction(this.idea.status);
      await this.searchSubmission(true);
      this.refreshPage();
    },
    isIdeaContest(ideaId) {
      const idea = this.listIdea.filter(
        idea => idea.id.toString() === ideaId.toString()
      );
      // console.log(`idea::`, idea);
      return idea && idea.length > 0 && idea[0].status === 'idea_contest';
    }
  },
  async created() {
    await this.fetchData();
    await this.searchSubmission(true);
    const periodRes = await periodCommon.search('', 1, 1000);
    this.listPeriod = periodRes.items;
    // console.log(`submission::`, this.submission);
    const submissions = [...this.submission];
    this.listIdea = await this.getIdeaList(submissions);
    // console.log(`listIdea;;`, this.listIdea);
    // this.ideaActionsList = await this.getIdeaActionsList(submissions);
    // console.log(`this.ideaActionsList::`, this.ideaActionsList)
  },
  mounted() {
    this.colorScoring = {
      gold: '#FFDF70',
      silver: '#c0c4cc',
      bronze: '#ec8553',
      consolation: '#99b3ff'
    };
    this.listMedal = [
      { code: 'gold', name: 'Vàng' },
      { code: 'silver', name: 'Bạc' },
      { code: 'bronze', name: 'Đồng' },
      { code: 'consolation', name: 'Khuyến khích' },
      { code: 'noMedal', name: 'Chấm điểm' }
    ];
    let updates = {};
    this.listMedal.map(function(medal, index) {
      updates[`score_${medal.code}`] = {
        id: index,
        medal: medal.code !== 'noMedal' ? medal.code : 'Chấm điểm'
      };
    });
    this.scoringUpdates = updates;
  },
  watch: {
    pageIndex: {
      immediate: false,
      async handler(newVal, oldVal) {
        await this.searchSubmission(false);
      }
    }
  }
};
</script>

<style scoped>
@import '../../assets/css/filter_customs.css';
@import '../../assets/css/table_customs.css';
</style>



// WEBPACK FOOTER //
// src/components/pages/IdeasExamination.vue